import { useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";

import { ManageRolesStoreType } from "./manage_roles_store.types";
import { ManageRolesStoreContext } from "./manage_roles_store_context";

export const useManageRolesStoreContext = () => useContext(ManageRolesStoreContext);

export const useManageRolesStore = <U>(selector: (state: ManageRolesStoreType) => U) => {
  const store = useManageRolesStoreContext();
  return useStore(store, useShallow(selector));
};

export const useManageRolesStoreActions = () => {
  const store = useManageRolesStoreContext();
  return useStore(store, (state) => state.actions);
};
